export function getChatConversationId(storageKey) {
  const fallbackId = `chat-${Date.now()}-${Math.random()
    .toString(36)
    .slice(2)}`;

  if (typeof window === "undefined" || !window.localStorage) {
    return fallbackId;
  }

  try {
    const existingId = window.localStorage.getItem(storageKey);

    if (existingId) {
      return existingId;
    }

    const randomId =
      window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : fallbackId;
    const nextId = `chat-${randomId}`;

    window.localStorage.setItem(storageKey, nextId);

    return nextId;
  } catch (error) {
    return fallbackId;
  }
}
